/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './transaction_info';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "BatchDeleteCatalogObjectsRequest": {
                        "fields": {
                          "objectIds": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "transactionInfo": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.TransactionInfo",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "BatchDeleteCatalogObjectsResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "deletedObjectIds": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "deletedAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "lockToken": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.BatchDeleteCatalogObjectsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.BatchDeleteCatalogObjectsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BatchDeleteCatalogObjectsRequest @ squareup/connect/v2/catalog/interfaces/batch-delete-catalog-obj.proto at 19:1
 */
export const BatchDeleteCatalogObjectsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.BatchDeleteCatalogObjectsRequest');
fixType(BatchDeleteCatalogObjectsRequest, {
  objectIds: {
    required: true
  }
});
Builder.createAndAttachToType(BatchDeleteCatalogObjectsRequest);
/**
 * SOURCE BatchDeleteCatalogObjectsResponse @ squareup/connect/v2/catalog/interfaces/batch-delete-catalog-obj.proto at 41:1
 */
export const BatchDeleteCatalogObjectsResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.BatchDeleteCatalogObjectsResponse');
fixType(BatchDeleteCatalogObjectsResponse);
Builder.createAndAttachToType(BatchDeleteCatalogObjectsResponse);